var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CabeceraModal",
    {
      attrs: { titulo: "Editar Configuración de Autorización" },
      on: {
        cerrar: function($event) {
          return _vm.$emit("cerrarEditar")
        }
      }
    },
    [
      _c("div", { staticClass: "cabecera" }, [
        _c(
          "div",
          { staticClass: "botones" },
          [
            _c(
              "v-btn",
              {
                staticClass: "cabeceraBtnGuardar",
                attrs: { disabled: !_vm.permitirGuard },
                on: { click: _vm.guard }
              },
              [
                _c("span", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.permitirGuard
                          ? "Guardar"
                          : "Complete los campos obligatorios (*)"
                      ) +
                      "\n        "
                  )
                ])
              ]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }